import { Container, Row, Col, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import styled from "styled-components"

import Navigation from '../components/Layout/Navigation';
import Footer from '../components/Layout/Footer';

import '../components/GlobalStyle.css';
import '../components/Backgrounds/Backgrounds.css';

import { FadeLoad, FadeLoadDelay } from '../components/styled/Motion.styled';
import { CTAContact } from '../components/Layout/CTA';
import { ContactForm } from '../components/ScheduleDemoComponents/ContactForm';


const FormCard = styled.div`
    box-shadow: 4px 4px 20px rgba(0, 0, 0, .25);
    border-radius: .5rem;
    padding: 1rem;
    background-color: #ffffff;
`


const ScheduleDemo = () => {
    return (
        <>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Schedule a Demo</title>
                <link rel="canonical" href="https://bestpayment.solutions/schedule-demo" />
            </Helmet>
            <Navigation />
            <Container fluid className='vh-75 py-5 circle-bg-1 bg-cream'>
                <Row className='align-items-center justify-content-evenly'>
                    <Col lg={4} md={6}>
                        <FadeLoad>
                            <h2 className='fw-bold fs-24 color-sky-tint-1'>Contact Us</h2>
                            <h1 className='fs-60'>
                                Let's talk about solutions!
                            </h1>
                            <p>
                                Are you ready to take the next step? Want to see a demo of what we can do for you? Call or message us today and we’ll get you on your way to success.
                            </p>
                            <p className='fw-bold border-bottom pb-3'>
                                Monday - Friday 8:00am - 4:00pm PST
                            </p>
                            <p className='fw-bold'>
                                800.371.6801
                            </p>
                            <p className='fw-bold'>
                                info@bestpayment.solutions
                            </p>
                        </FadeLoad>
                    </Col>
                    <Col lg={4} md={6} className='mt-4 mt-md-0'>
                        <FadeLoadDelay>
                            <FormCard>
                                <ContactForm />
                            </FormCard>
                        </FadeLoadDelay>
                    </Col>
                </Row>
            </Container>
            <CTAContact />
            <Footer />
        </>
    );
}

export default ScheduleDemo;